<template lang="html">
  <div class="input-group">
    <input
      :class="[customClass, {'is-invalid': errorMessage }]"
      :type="type"
      :id="id"
      :value="value"
      :readonly="readonly"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)" />
    <div class="input-group-append">
      <button @click="$emit('fire')" class="btn " type="button"><i v-if="icon" :class="icon.css"></i>  <span v-else >{{btnText}}</span></button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { default: '' }, // can be different types of values
    type: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    customClass: { type: String, default: 'form-control' },
    readonly: { type: Boolean },
    icon: { type: Object },
    btnText: { type: String },
    id: { type: String },
    errorMessage: {
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.input-group-append {
  button {
    background-color: $gray-200;
    border-right: 1px solid #ced4da;
    border-top: 1px solid #ced4da;
    border-bottom: 1px solid #ced4da;
  }
}
</style>
